import { produce } from "immer"
const initialState = {
    data: {
        approve: {},
        rejected: {},
        provisional: {},
        save: {},
        completed: {},
        ongoing: {},
        recomended: {},
        available: {}
    }
}
export const TaskTListReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'FETCH_TASK_LIST':
            return produce(state, (draft) => {

                const { type, data } = action.payload;
                if (type && draft.data.hasOwnProperty(type)) {
                    draft.data[type] = data;
                }
            })
        case "REMOVE_TASK_LIST":
            return produce(state, (draft) => {
                draft.data = initialState.data;
            })

        default:
            return state

    }
}